import type { PropsWithChildren } from "react";

import type { FormFieldGroupProps } from "@/ui/composed/form/FormFieldGroup";
import FormFieldGroup from "@/ui/composed/form/FormFieldGroup";
import { VStack } from "@/ui/layout";

interface FormPageProps extends ViewWithTestID, PropsWithChildren {
  groups: FormFieldGroupProps[];
}

const FormPage = ({ children, groups, testID }: FormPageProps) => {
  return (
    <VStack gap={12} testID={testID}>
      {groups.map((group) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <FormFieldGroup key={group.testID} {...group} />
      ))}
      {children}
    </VStack>
  );
};

export type { FormPageProps };
export default FormPage;
